//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { VIPICON } from '@/util/constant';
export default {
  props: {
    /**
     * friendPop为复用组件，list数组字段需统一
     * list: Array<{
     *  nick: string,
     *  headurl: string,
     *  level: string,
     *  rightText: string
     * }>
     */
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dot: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    levelIcon: function levelIcon(level) {
      return +level > 0 ? VIPICON[level] : '';
    }
  }
};